import AutocompleteDropdown from './fragments/AutocompleteDropdown';
import getEmojiIconCode from './helpers/getEmojiIconCode';

export default {
  'emoji/fragments/AutocompleteDropdown': AutocompleteDropdown,
  'emoji/helpers/getEmojiIconCode': getEmojiIconCode,
};
